import { useRef } from 'preact/hooks';
import { useBlockStore } from '../stores/BlockStore';
import { useConfigStore } from '../stores/ConfigStore';

export default function useValidatedBlocks(blockIdArray = [], showErrors) {
	const blockState = useBlockStore();
	const { blocks } = useConfigStore();

	const firstInvalid = useRef(null);

	const pageValid = blockIdArray.every(blockId => {
		const state = blockState[blockId];
		const block = blocks[blockId] ?? {};

		if (!state?.isVisible) {
			return true;
		}

		if (block.typeName === 'contact') {
			const contactValid = Object.keys(block.properties.elements).every(elementKey => {
				const element = block.properties.elements[elementKey];

				if (element.subelements) {
					return Object.keys(element.subelements).every(subElementKey => {
						const subElement = element.subelements[subElementKey];
						return !state[subElement.data_field]?.showError;
					});
				}

				return !state[element.data_field]?.showError;
			});

			if (showErrors && !contactValid && !firstInvalid.current) {
				firstInvalid.current = Number(block.id);
			}

			return contactValid;
		}

		if (showErrors && state.showError && !state.value && !firstInvalid.current) {
			firstInvalid.current = Number(block.id);
		}

		return !state.showError;
	});

	return {
		pageValid,
		firstInvalid: firstInvalid.current
	};
}
